import * as React from 'react';

import { ICurrency } from '@containers/App/model';

import { Line } from '../SelectedVariant/styled';

import {
  ConditionalVoucherDiscount,
  IConditionalVoucherDiscount,
} from './ConditionalVoucherDiscount';
import { VoucherDiscountContext } from './context';
import { MultiTierVoucherDiscount } from './MultiTierVoucherDiscount';
import { LineWrapper } from './styled';
import { isConditionalDiscount } from './utils';
import { IVoucherDiscount, VoucherDiscount } from './VoucherDiscount';

interface IVoucherDiscountProps {
  voucherDiscount: IVoucherDiscount | IConditionalVoucherDiscount;
  currency: ICurrency;
  isUnderSelectBox?: boolean;
  hideLine?: boolean;
  isArrowHidden?: boolean;
}

export const VoucherDiscountMaster = ({
  voucherDiscount,
  hideLine,
  ...rest
}: IVoucherDiscountProps) => {
  const getComponent = () => {
    if (isConditionalDiscount(voucherDiscount)) {
      return voucherDiscount.discountConditions.length > 1 ? (
        <MultiTierVoucherDiscount voucherDiscount={voucherDiscount} />
      ) : (
        <ConditionalVoucherDiscount voucherDiscount={voucherDiscount} />
      );
    }
    return <VoucherDiscount voucherDiscount={voucherDiscount} />;
  };

  const hasBlackFridayDiscount =
    !!voucherDiscount.tags?.includes('summerblackfriday') ||
    !!voucherDiscount.tags?.includes('blackfriday');

  return (
    <VoucherDiscountContext.Provider
      value={{ ...rest, hasBlackFridayDiscount }}
    >
      {getComponent()}

      {!hideLine && (
        <LineWrapper>
          <Line />
        </LineWrapper>
      )}
    </VoucherDiscountContext.Provider>
  );
};
